import { getDefaultExportFromCjs } from './_commonjsHelpers.js';
import { __require as requireClassnames } from '../node_modules/classnames/index.js';

var classnamesExports = requireClassnames();
var classNames = /*@__PURE__*/getDefaultExportFromCjs(classnamesExports);

export { classNames as default };
